// import $ from 'jquery';

$(() => {

	$(".share-toggle-button").on("click", function (event) {
		event.stopPropagation();
		$(this).parent().toggleClass("is-active");
	});

	$('body').on('click', function (event) {
		$('#share-wrapper').removeClass('is-active');
	});

});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/share-button/index.js